import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Deferred, EinreichungComponents } from '@ebeihilfe/core';
import {
  Antrag,
  EinreichungComponentType,
  EinreichungStep,
  EinreichungStepResultType,
  PopulateUnfinishedAntrag,
} from '@ebeihilfe/einreichung-old';
import { NoteComponent } from '@ebeihilfe/web-shared/note';
import { TranslateModule } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-ebeihilfe-populate-unfinished-antrag',
  templateUrl: './populate-unfinished-antrag.component.html',
  styleUrls: ['./populate-unfinished-antrag.component.scss'],
  imports: [MatCardModule, TranslateModule, MatButtonModule, MatProgressSpinnerModule, NoteComponent],
})
export class PopulateUnfinishedAntragComponent
  extends PopulateUnfinishedAntrag
  implements EinreichungComponentType, OnInit
{
  public component = PopulateUnfinishedAntragComponent;
  public name = EinreichungComponents.PopulateWithUnfinishedAntrag;
  // Muss vor StartupInformationComponent (INIT + 1) laufen, damit dessen
  // Kurzantrag-Metadaten-Check auf dem ggf. wiederhergestellten Antrag prüft,
  // statt auf dem frischen Stub, der hier noch keine Metadaten haben kann.
  public override prio = EinreichungStep.INIT;

  public async ngOnInit(): Promise<void> {
    return super.ngOnInit();
  }

  public async handle(
    antrag: Antrag,
    instance: PopulateUnfinishedAntragComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }
}
